import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import ReactMarkdown from 'react-markdown'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchMenu, fetchFood } from '../redux/actions';
import Loader from '../components/Loader';
import slug from 'slug';
import Helmet from 'react-helmet';
import './MenuPage.css';

//import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock';
import RenderProduct from '../components/RenderProduct';
import RenderCategory from '../components/RenderCategory';

class MenuPage extends Component {

  componentDidMount() {
    const locale = this.props.intl.locale;

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }
    
    if (!this.props.food.fields) {
        this.props.fetchFood('menu', locale);
    }
  }

  componentDidUpdate() { 

    const menuSlug = this.props.match.params.slug;

    const menus = this.props.menus;
    const menu = (menus.find(menu => slug(menu.fields.title.toLowerCase()) === menuSlug));

    if (menus.length && !menu) {
      this.props.history.replace('/menu/' + slug(menus[0].fields.title.toLowerCase()));
    }
  }

  render() {
	const food = this.props.food;  
	

	const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }

    const menuSlug = this.props.match.params.slug;
    //const menuSubSlug = this.props.match.params.subslug;
    const {menus, categories, products} = {...this.props};

    const productGroups = categories.filter(category => isItemValid(category, this.props.date));
    
    var tempLead = 'Spending time with our loved ones enjoying good food and drink, is the most valuable time of all. Even though we sometimes take our food slightly seriously, we want our guests to have fun while eating it. Our menu is an ode to the wonderful ingredients that our seas and lakes have to offer. We are all about the freshest, sustainably grown and harvested seafood. These, as well as their origin, are at the core of our craft. Fresh oysters, shellfish, fish and mussels are prepared honouring classic preparation methods, however bravely adapted.';
    if(this.props.intl.locale === 'fi') {
    	tempLead = 'Parhaimpia ovat yhdessä jaetut hetket hyvän ruoan ja juoman äärellä! Vaikka toisinaan otamme ruoan valmistuksen jopa vakavasti, tarjoiluistamme nauttimisen tulee olla hauskaa. Ruokalistamme on kunnianosoitus merten ja vesistöjen maukkaimpia antimia kohtaan. Keskitymme raaka-aineissa vahvasti tuoreisiin, vastuullisesti kasvatettuihin ja pyydettyihin mereneläviin. Meillä raaka-aineet ja niiden alkuperä ovat kaiken keskiössä. Tuoreet osterit, äyriäiset, kalat ja simpukat valmistetaan klassisia ruoanvalmistustapoja kunnioittaen, kuitenkin rohkeasti soveltaen.';
    } 
    
    var bgImage = null;
    for(let i=0;i < menus.length; i++) {
    	if(menuSlug === slug(menus[i].fields.title.toLowerCase()) && menus[i].fields.image && menus[i].fields.image.fields.file.url) {
    		bgImage = menus[i].fields.image.fields.file.url;
    	}
    }

    return (
      <div className="menu">
	      	{!food.elements && <Loader/>}
	      	{food.elements && food.elements[0] && 
	      		<div style={bgImage ? { backgroundImage: 'url(' + bgImage + '?fm=jpg&q=80)'}:{}}>
	      			<Helmet title={food.elements[0].fields.title} />
	      			<div className="category">
		      			<FullbleedContentBlock key={food.elements[0].sys.id} align="center" fields={{
		                    heading: food.elements[0].fields.heading,
		                    lead: food.elements[0].fields.lead ? food.elements[0].fields.lead : tempLead
		                }} />
		      			<div className="container">
					      	<nav className="subcategory-nav">
					      		{ menus.map((menu) => {					    
					      			
					      			
					      		   if(menu.fields.showInNavigation) {					      		
						      		   return (
						      		      <NavLink to={'/menu/'+slug(menu.fields.title.toLowerCase())} key={menu.sys.id} activeClassName="active">{menu.fields.title}</NavLink>
						      			)
					      		   }
					      		   
					      		   return null;
					      		  }) 
					      		}
					      	</nav>
					      	<div className="products-wrapper">
		                      <div className="products-categories">
		                        { menus.map((menu) => {		                        
		                        	return (
		                        		<div className={ menuSlug === slug(menu.fields.title.toLowerCase()) ? 'tab-menu-content active': 'tab-menu-content'} key={menu.sys.id}>
				                      	{(menu.fields.longTitle || menu.fields.description) &&
				                          <div className="category-intro">
				                            {menu.fields.longTitle && <h3>{menu.fields.longTitle}</h3>}
				                            {menu.fields.description && <ReactMarkdown source={menu.fields.description} />}
				                          </div>
				                        }
				                        {menu.fields.children && menu.fields.children.map((child, index) => {
				                          let product = products.find((p) => {
				                            return p.sys.id === child.sys.id
				                          })
				                          let category = productGroups.find((p) => {
				                            return p.sys.id === child.sys.id
				                          })
		
				                          if(product) {
				                            return(
				                              <RenderProduct product={product} key={product.fields.title} {...this.props} />
				                            )
				                          }
		
				                          if(category) {
				                            return(
				                              <RenderCategory category={category} key={category.fields.title} {...this.props} />
				                            )
				                          }
		
				                          return null;
				                        })}
				                        
				                        {menu.fields.children && menu.fields.children.map((child) => {
				                            let menu = menus.find((p) => {
				                              return p.sys.id === child.sys.id
				                            })

				                            if(menu) {
				                              return(
				                                <div className={'submenu cols-'+menu.fields.columns} key={menu.fields.title} id={slug(menu.fields.title.toLowerCase())}>
				                                  <h3>{menu.fields.title}</h3>
				                                  {menu.fields.description && <p>{menu.fields.description}</p>}
				                                  {menu.fields.children && menu.fields.children.map((child) => {
				                                    let product = products.find((p) => {
				                                      return p.sys.id === child.sys.id
				                                    })
				                                    let category = productGroups.find((p) => {
				                                      return p.sys.id === child.sys.id
				                                    })
				                                    if(product) {
				                                      return(
				                                        <RenderProduct product={product} key={product.fields.title} {...this.props} />
				                                      )
				                                    }

				                                    if(category) {
				                                      return(
				                                        <RenderCategory category={category} key={category.fields.title} {...this.props} />
				                                      )
				                                    }

				                                    return null;
				                                  })}
				                                </div>
				                              )
				                            }
				                            return null;
				                          })}
				                        </div>
		                        	)
					      		  }) 
					      		}
		                      </div>
		                    </div>
					    </div>
		      		</div>
	      		</div>
	         }
	   </div>
    );  
  }
}

MenuPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  menus:state.menus,
  food:state.food,
  date:state.date,
  products:state.products,
  categories:state.categories
});

const mapDispatchToProps = {
  fetchMenu,
  fetchFood
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(MenuPage));



// WEBPACK FOOTER //
// ./src/containers/MenuPage.js